export default __webpack_public_path__ + "static/media/preloader.53a391a3.gif";